export default {
  heading: 'Bugsweeper',
  difficulty: 'Difficulty',
  easyDifficulty: 'Easy',
  mediumDifficulty: 'Medium',
  expertDifficulty: 'Expert',
  audioSettings: 'Audio settings',
  soundVolume: 'Sound',
  musicVolume: 'Music',
  playBtn: 'Play',
  mineTheme: 'Mine theme',
  languageSettings: 'Language',
  keybinds: 'Keybinds',
  keybindUp: 'Up - Arrow Up ⬆',
  keybindDown: 'Down - Arrow Down ⬇',
  keybindLeft: 'Left - Arrow Left ⬅',
  keybindRight: 'right - Arrow Right ➡',
  keybindNewGame: 'New Game - N',
  score: 'Score',
  time: 'Time',
  back: 'Back',
};
